import { render, staticRenderFns } from "./CompanionContent.vue?vue&type=template&id=83493a4a&"
import script from "./CompanionContent.vue?vue&type=script&lang=js&"
export * from "./CompanionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports